import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "scorecard-container"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "custom-base-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "My Team")
], -1)
const _hoisted_4 = { class: "slider" }
const _hoisted_5 = { class: "slider-container" }
const _hoisted_6 = { class: "badge-slides slide" }
const _hoisted_7 = { class: "team-member" }
const _hoisted_8 = { class: "team-member-name" }
const _hoisted_9 = { class: "custom-base-block overline-pad-top" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "no-positive"
}
const _hoisted_13 = { class: "room-to-improve" }
const _hoisted_14 = { class: "top" }
const _hoisted_15 = { class: "middle" }
const _hoisted_16 = { class: "improve-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "search" }, null, -1)
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "mentions" }
const _hoisted_20 = {
  key: 0,
  class: "count"
}
const _hoisted_21 = { class: "mentions-label" }
const _hoisted_22 = {
  key: 1,
  class: "no-negative"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", null, "Nothing! Keep up the great work!", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "right-angle"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "14",
  viewBox: "0 0 8 14",
  width: "8",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    fill: "url(#pattern0)",
    height: "14",
    opacity: "0.2",
    transform: "matrix(-1 0 0 1 8 0)",
    width: "8"
  }),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("pattern", {
      id: "pattern0",
      height: "1",
      patternContentUnits: "objectBoundingBox",
      width: "1"
    }, [
      /*#__PURE__*/_createElementVNode("use", {
        transform: "scale(0.125 0.0714286)",
        "xlink:href": "#image0"
      })
    ]),
    /*#__PURE__*/_createElementVNode("image", {
      id: "image0",
      height: "14",
      width: "8",
      "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAmElEQVQoFWNkwAJUeGxFWTg5tv9n+P+dCV0eLMnFsZ+BkcGYgYGBgxFZAVySgUGbgYHh6p9vPxzhCrBJ3vly+DVYAS5JkOmM+CRBCphArmVAshNkLLK7MHyBLAk24c/3H54gF4NMYeHi2A+yElkRYUfCVONyLDwcQAqxKUJRAFKkzGMlxsrFvQ/ss/8MZzEUwBVxcm8DRRYAiUZTfr5p+UMAAAAASUVORK5CYII="
    })
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "custom-base-block overline-pad-top" }
const _hoisted_29 = { class: "achievement-container" }
const _hoisted_30 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScorecardHeader = _resolveComponent("ScorecardHeader")!
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_ScorecardBadge = _resolveComponent("ScorecardBadge")!
  const _component_BaseBlock = _resolveComponent("BaseBlock")!

  return (_ctx.scorecard)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ScorecardHeader, {
            "location-text": _ctx.locationText,
            "rating-label": _ctx.ratingLabel,
            scorecard: _ctx.scorecard,
            "is-team-member-view": !!_ctx.teamMemberUserId,
            onTrend: _ctx.goTrend,
            onRank: _ctx.goRank
          }, null, 8, ["location-text", "rating-label", "scorecard", "is-team-member-view", "onTrend", "onRank"])
        ]),
        (_ctx.teamMembers.length > 0 && !_ctx.teamMemberUserId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (member) => {
                      return (_openBlock(), _createBlock(_component_RouterLink, {
                        key: member.user_id,
                        to: {
                                name: 'scorecardHomeUser',
                                params: { teamMemberUserId: member.user_id },
                            }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_AvatarOrInitials, {
                              size: 75,
                              user: member,
                              class: "team-member-avatar"
                            }, null, 8, ["user"]),
                            _createElementVNode("p", _hoisted_8, _toDisplayString(member.name), 1)
                          ])
                        ], undefined, true),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Typography, { variant: "overline" }, {
            default: _withCtx(() => [
              _createTextVNode("Your customers love")
            ], undefined, true),
            _: 1
          }),
          (_ctx.sortedBadges)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass({ slider: _ctx.$isMobile })
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'slider-container': _ctx.$isMobile })
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([{
                                'badge-slides': _ctx.$isMobile,
                                slide: _ctx.$isMobile,
                                'desktop-badges': !_ctx.$isMobile,
                            }, "badges-container"])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBadges, (info) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: info.value,
                          class: "slide badge",
                          onClick: ($event: any) => (
                                        info.count > 0 && _ctx.goBadge(info.value)
                                    )
                        }, [
                          _createVNode(_component_ScorecardBadge, {
                            label: info.label,
                            "show-count": !_ctx.scorecard.v2,
                            "badge-id": info.badgeId,
                            "count-unseen": 
                                            info.countUnseen.toString()
                                        ,
                            count: info.percentage + '%'
                          }, null, 8, ["label", "show-count", "badge-id", "count-unseen", "count"])
                        ], 8, _hoisted_11))
                      }), 128))
                    ], 2)
                  ], 2)
                ], 2)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, " Just waiting for a scorecard to be set up... "))
        ]),
        _createVNode(_component_BaseBlock, { class: "things-to-work-on-base-block" }, {
          default: _withCtx(() => [
            _createVNode(_component_Typography, { variant: "overline" }, {
              default: _withCtx(() => [
                _createTextVNode("Your customers suggest")
              ], undefined, true),
              _: 1
            }),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    (_ctx.hasNegative)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "item-content",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goRoomToImproveDetail && _ctx.goRoomToImproveDetail(...args)))
                        }, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.mostNegative.label || _ctx.mostNegative.value), 1),
                          _createElementVNode("div", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.mostNegative.count) + " mention" + _toDisplayString(_ctx.mostNegative.count > 1 ? 's' : '') + " ", 1),
                            (_ctx.mostNegative.countUnseen)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, " +" + _toDisplayString(_ctx.mostNegative.countUnseen), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.thingsToWorkOnDescription), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                  ])
                ]),
                (_ctx.hasNegative)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hasNegative)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "see-all",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goRoomToImproveList && _ctx.goRoomToImproveList(...args)))
                  }, " See all "))
                : _createCommentVNode("", true)
            ])
          ], undefined, true),
          _: 1
        }),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_Typography, { variant: "overline" }, {
            default: _withCtx(() => [
              _createTextVNode("You’re Awesome!")
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badgeAchievements, (achievement) => {
              return (_openBlock(), _createElementBlock("div", {
                key: achievement.type,
                class: "achievement",
                onClick: ($event: any) => (_ctx.goAchievement(achievement.badgeId))
              }, [
                _createVNode(_component_ScorecardBadge, {
                  label: achievement.label,
                  "data-id": 'pendo-achievement-badge',
                  "show-count": false,
                  "badge-id": achievement.badgeId,
                  "badge-type": 'achievement',
                  "count-unseen": achievement.countUnseen.toString(),
                  count: achievement.count.toString()
                }, null, 8, ["label", "badge-id", "count-unseen", "count"])
              ], 8, _hoisted_30))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}